import Header from "./Header";
import Footer from "./Footer";

export default function PageLayout({ children, noFooter = false }) {
    return (
        <div className="relative min-h-screen">
            <div className="grain-overlay" aria-hidden />
            <Header />
            <main className="relative z-10 pt-[68px]">{children}</main>
            {!noFooter && <Footer />}
        </div>
    );
}
